/** NEW UI theme */

import { AppTheme } from './types';

// Define the typography structure
const typography = {
  h1: {
    fontSize: '40px',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  h2: {
    fontSize: '32px',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  h3: {
    fontSize: '28px',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  h4: {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  h5: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h6: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  'body-16': {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  'body-14': {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  'body-12': {
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  'body-10': {
    fontSize: '10px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
};

export const adsparkTheme: AppTheme = {
  name: 'adspark-theme',
  colors: {
    primary: {
      normal: '#2F5C8F',
      medium: '#133865',
      dark: '#0B2340',
    },
    secondary: {
      normal: '#F3E8F6',
      medium: '#D9B6DF',
      dark: '#A86BB3',
    },
    background: {
      light: '#F8F8F7',
      medium: '#F2F2F2',
      dark: '#E8E8E8',
    },
    technical: {
      adaptive: '#131313',
      'adaptive-reverse': '#FFFFFF',
      black: '#040404',
      gray: {
        60: '#6B6B6B',
        30: '#B3B3B3',
        15: '#D9D9D9',
        5: '#F2F2F2',
      },
      white: '#FFFFFF',
    },
    status: {
      success: {
        normal: '#00C072',
        highlight: '#E6F8F1',
        light: '#C2F0DD',
        dark: '#99E6C7',
      },
      error: {
        normal: '#FF5959',
        highlight: '#FFE5E5',
        light: '#FFA8A8',
        dark: '#DC0000',
      },
      warning: {
        normal: '#FF7801',
        highlight: '#FFF9EB',
        light: '#FFBB66',
        dark: '#BF5F00',
      },
      info: {
        normal: '#00A4FF',
        highlight: '#E6F6FF',
        light: '#99CFFF',
        dark: '#006BC9',
      },
    },
    decorative: {
      forest: '#00DFAF',
      frost: '#C480FF',
      babyPink: '#FFB4F9',
      ultraViolet: '#808FFF',
      sea: '#80C6FF',
      barbiePink: '#FF80C6',
      honey: '#FFA641',
      leaf: '#80FFAC',
      indigo: '#004BA0',
      background: {
        forest: '#CCFFF4',
        frost: '#F3E5FF',
        babyPink: '#FFE5FD',
        ultraViolet: '#E5E9FF',
        sea: '#E5F4FF',
        barbiePink: '#FFE5F4',
        honey: '#FFF3E5',
        leaf: '#E5FFEE',
        indigo: '#E5F1FF',
      },
    },
  },
  typography,
};

export const adsparkThemes = {
  light: adsparkTheme,
  dark: adsparkTheme,
};
